<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div v-if="FastpaymentData.length != 0 && $session.get('AccessMenu').filter((x) => x.id == 32)[0].isMenu" class="col-12 p-2">
        <net-pa-card v-if="$store.state.renderComponent">
          <template v-slot:header>
            <h6><i class="fas fa-credit-card ml-2"></i>پرداخت سریع</h6>
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-md-4 col-12">
                <div class="border bnp-rounded p-0 text-center bg-dark text-light">
                  <div class="row">
                    <div class="col-12 text-center p-1 pt-2">
                      <h6 class="font-weight-bold text-light"><i class="fas fa-circle font-weight-bold text-warning ml-2"></i>کل مبلغ سررسید شده</h6>
                    </div>
                    <div class="col-12" style="min-height: 24vh">
                      <div class="row">
                        <div class="col-12 text-center mt-2 mx-2">
                          <span class="text-light">مبلغ سررسید شده بابت </span>
                          <span class="text-warning" style="font-size: 15px">{{ TotalFastPay.VamCoutFastPay }}</span>
                          <span class="text-light"> وام </span>
                        </div>
                        <div class="col-12 text-center mt-1 mx-2">
                          <span class="text-light">مبلغ جریمه </span>
                          <span class="text-danger" style="font-size: 15px">{{ $Comma3ragham(TotalFastPay.SumJarmieFastPay) }}</span>
                        </div>
                        <div class="col-12 text-center mt-1">
                          <span class="text-light"> مبلغ قابل پرداخت: </span>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-6 mt-2 text-center">
                          <label style="font-size: 20px" class="border-bottom boroder-light">{{ $Comma3ragham(TotalFastPay.SumMabFastPay + '') }}</label>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-12 text-center tex-light my-1">
                          <span class="text-light">{{ $Mab2persianRial(TotalFastPay.SumMabFastPay + '') }}</span>
                        </div>
                        <div class="col-3 mt-1"></div>
                        <div class="col-6 mt-1">
                          <button class="bnp-rounded text-light btn w-100 mb-1" :disabled="TotalFastPay.SumMabFastPay == 0" @click="Pay" style="background: #435ebe !important">&nbsp; پرداخت سریع &nbsp;</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8 mt-md-0 mt-2 col-12" style="max-height: 220px; overflow-y: scroll">
                <div class="row">
                  <div v-for="(item, index) in FastpaymentData" :key="index" class="col-12 border-right border-success Netpa-Shadow-2 bg-white p-1 mt-2 px-4" style="border-right: solid 2px !important">
                    <div class="row">
                      <div class="col-6 mt-md-0 mt-2 text-center col-md-2">
                        <span class="text-secondary">نام تسهیلات: </span> <br />
                        <small class="no-wrap">{{ item.desNoe }}</small>
                      </div>
                      <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                        <span class="text-secondary">شماره تسهیلات</span><br />
                        <small class="no-wrap" dir="rtl">{{ item.vCode }}</small>
                      </div>
                      <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                        <span class="text-secondary">تاریخ قسط</span><br />
                        <small class="no-wrap" dir="rtl">{{ item.minTarGhestBedehkar }}</small>
                      </div>
                      <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                        <span class="text-secondary">مبلغ قابل پرداخت</span><br />
                        <small dir="rtl">{{ $Comma3ragham(item.mablghPardakht + '') }}</small>
                      </div>
                      <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                        <span class="text-secondary">مبلغ جریمه</span><br />
                        <span class="text-danger" dir="rtl">{{ item.wwwjarime == null ? 0 : $Comma3ragham(item.wwwjarime + '') }}</span>
                      </div>
                      <div class="col-12 mt-md-0 mt-2 mb-2 text-center col-md-1" dir="rtl">
                        <span class="">
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input InputText" :checked="FastpaymentData[index].Active" v-model="FastpaymentData[index].Active" :id="FastpaymentData[index].vCode + 'active'" />
                            <label class="custom-control-label mt-2 Pointer" :for="FastpaymentData[index].vCode + 'active'">انتخاب</label>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      
      <div class="col-12 p-2 col-md-12 col-lg-12" >
        <net-pa-card style="max-height:300px; overflow-y: auto;">
          <template v-slot:header>
            <h6>
              <i class="fas fa-bell ml-2 fa-2x animate__animated animate__swing animate__infinite text-warning" style="font-size:20px;"></i>تابلو اعلانات </h6
          ></template>
          <template v-slot:content>
            <div v-if="Tabloo == 'loading'" class="row pr-3">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="row pr-3">
              <div v-for="(item, index) in Tabloo" :key="index" class="col-12 pr-0">
                <div class="row">
                  <div class="col-12 py-1 mx-0">
                    <i class="fas fa-comment-alt ml-2 text-info"></i>
                    <span class="mr-3">{{ item.zamanInsert }}
                      <span v-if="item.txtMatnTabloElanat.length > 60" class="badge float-left Pointer p-1 badge-info font-weight-normal"
                        style="font-size: 10px !important"
                        @click="ShowFullNotif(item)"
                        data-toggle="modal"
                        data-target="#Modal-light">مشاهده کامل</span></span>
                    <span class="font-weight-bold d-block" style="font-size:16px !important ; color: #ff0000e8;" > {{ item.subjectTabloElanat }}</span>
                    
                  </div>
                  <div class="col-12 px-1 mt-2 container-fluid" style="max-height: 25vh">
                    <div class="row">
                      <div class="col-12" style="max-height: 5vh; max-width: 100%; text-overflow: ellipsis !important; font-size: 13px;">
                        {{ item.txtMatnTabloElanat.substring(0, 180) }}
                        <span v-if="item.txtMatnTabloElanat.length > 180">...</span>
                      </div>
                      <!-- <div class="col-12 text-left">
                        <span v-if="item.txtMatnTabloElanat.length > 180" class="badge Pointer p-1 badge-success font-weight-normal" style="font-size: 10px !important" @click="ShowFullNotif(item)" data-toggle="modal" data-target="#Modal-light">
                          مشاهده کامل</span
                        >
                      </div> -->
                    </div>
                    <hr />
                  </div>
                  
                </div>
              </div>
              <div class="col-12 text-center p-1"></div>
              <div v-if="TablooLength < 1" class="alert alert-primary w-100 text-right">
                <p style="font-size: 16px !important">اعلانی یافت نشد</p>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-12 p-2 col-md-12 p-1 col-lg-6">
        <net-pa-card>
          <template v-slot:header>
            <h6><i class="fas fa-bolt ml-2" aria-hidden="true"></i>دسترسی سریع</h6>
          </template>
          <template v-slot:content>
            <div class="row h-100">
              <div class="col-6 p-2">
                <router-link :to="'Turnover'">
                  <div class="w-100 text-center rounded p-2 bg-dark text-light" style="font-size: 15px"><i class="fas fa-receipt p-1 ml-2 text-warning"></i> صورت حساب</div>
                </router-link>
              </div>
              <div class="col-6 p-2" v-if="accessMenu1">
                <router-link :to="{ name: 'Debtor' }">
                  <div class="w-100 text-center rounded p-2 bg-dark text-light" style="font-size: 15px"><i class="fas fa-arrow-up p-1 ml-2 text-warning"></i>برداشت از حساب</div>
                </router-link>
              </div>
              <div class="col-6 p-2" v-if="accessMenu2">
                <router-link :to="{ name: 'Deposit', params: { IsShowComboHesab: true } }">
                  <div class="w-100 text-center rounded p-2 bg-dark text-light" style="font-size: 15px"><i class="fas fa-arrow-down ml-2 text-warning"></i> واریز به حساب</div>
                </router-link>
              </div>
              <div class="col-6 p-2" v-if="accessMenu3">
                <router-link
                  :to="{
                    name: 'Deposit',
                    params: { IsShowComboHesab: true, IsTashilat: true },
                  }"
                >
                  <div class="w-100 text-center rounded p-2 bg-dark text-light" style="font-size: 15px"><i class="fas fa-coins ml-2 text-warning"></i> پرداخت اقساط</div>
                </router-link>
              </div>
              <div class="col-6 p-2" v-if="accessMenu4">
                <router-link :to="{ name: 'DepositGroup' }">
                  <div class="w-100 text-center rounded p-2 bg-dark text-light" style="font-size: 15px"><i class="fas fa-coins ml-2 text-warning"></i> پرداخت گروهی</div>
                </router-link>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>

      
      <!-- درخواست ضمانت -->
      <div v-if="ListReqNeedVam && ListReqNeedVam.length != 0" class="col-12 mt-1 p-2">
        <net-pa-card :Classes="'bg-orange'" :IsMinus="false" :IdElement="'Zemanat'" v-if="$store.state.renderComponent">
          <template v-slot:header>
            <h6 class="text-dark"><i class="fas fa-exclamation-triangle ml-2"></i>درخواست ضمانت</h6>
          </template>
          <template v-slot:content>
            <div class="row boder-bottom pr-2 pl-3" v-for="nv in ListReqNeedVam" :key="nv.id">
              <div class="col-12 my-2 mx-1 w-100 Netpa-Shadow-2 mt-1 py-3">
                <div class="row">
                  <div class="col-md-3 col-12 text-center">
                    <div class="">
                      <small class="text-dark font-weight-bold mt-2"> {{ nv.subjectTabloElanat }} </small>
                    </div>
                    <div class="mt-1">
                      <small class="text-danger font-weight-bold mt-2" style="font-size: 14px"> {{ nv.desNoe }} </small>
                    </div>
                  </div>
                  <div class="col-md-3 col-12 text-center">
                    <span class="text-secondary"> مشخصات</span>
                    <small class="font-weight-bold mt-2"> {{ nv.nameFamily }} </small>

                    <div class="mt-1">
                      <span class="text-secondary"> کد ملی</span>
                      <small class="font-weight-bold mt-2"> {{ nv.codeMeli }} </small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <span class="text-secondary"> مبلغ تسهیلات </span>
                    <div>
                      <small class="text-danger font-weight-bold mt-2" style="font-size: 16px"> {{ $Comma3ragham(nv.mablagh) }} </small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <span class="text-secondary"> تاریخ درخواست </span>
                    <div class="mt-1">
                      <small class="text-dark font-weight-bold mt-2"> {{ nv.zamanInsert }} </small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <div @click="RqNeedVam(nv.id, 1)" class="badge badge-success p-1 px-3 py-1 font-weight-normal Pointer w-75" style="border-radius: 4px"><i class="fa fa-check ml-2"></i> تایید ضمانت</div>
                    <div @click="RqNeedVam(nv.id, 2)" class="badge badge-danger p-1 px-3 py-1 font-weight-normal Pointer mt-1 w-75"><i class="fa fa-times ml-2"></i> رد ضمانت</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div v-if="Moavaghaat && Moavaghaat.length != 0" class="col-12 p-2 col-md-12 col-lg-12">
        <net-pa-card :Classes="'bg-danger'" :IsMinus="true" :IdElement="'Moavaghaat'" v-if="$store.state.renderComponent">
          <template v-slot:header>
            <h6><i class="fas fa-exclamation-triangle ml-2"></i>اقساط معوقه</h6>
          </template>
          <template v-slot:content>
            <div v-for="(item, index) in Moavaghaat" :key="index" class="my-2 mx-1 w-100 Netpa-Shadow-2 mt-1 py-2">
              <div class="row mt-1">
                <div class="col-12 col-md-3 mt-1 text-center">
                  <span class="text-secondary"> {{ item.desNoe }}</span>
                  <small class="mt-2" dir="rtl"> {{ item.vCode }}</small>
                </div>
                <div class="col-12 col-md-2 text-center">
                  <span class="text-secondary"> تعداد اقساط معوقه </span>
                  <small class="text-danger mt-2" style="font-size: 18px !important"> {{ item.countMoavaghe }}</small>
                </div>
                <div class="col-12 col-md-3 text-center">
                  <span class="text-secondary"> مجموع معوقه </span>
                  <span class="text-danger" style="font-size: 18px !important"> {{ item.sumMoavaghe }}</span>
                  <small class="text-secondary mr-1" dir="rtl"> ریال</small>
                </div>
                <div class="col-12 col-md-2 text-center">
                  <i class="fas fa-calendar text-secondary ml-2 mt-1"></i><small class="" dir="rtl">{{ item.zamanInsert }}</small>
                </div>
                <div class="col-12 col-md-2 text-center">
                  <div class="btn btn-outline-dark rounded Pointer" v-if="item.tblSarfaslTypeId == 1">
                    <router-link
                      :to="{
                        name: 'LoanCardex',
                        params: { TaahodatId: item.id },
                      }"
                      ><i class="fas fa-plus text-dark/ ml-2"></i><small class="" dir="rtl">کاردکس</small></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-12 p-2 p-1">
        <net-pa-card v-if="$store.state.renderComponent">
          <template v-slot:header>
            <h6><i class="fas fa-chart-line ml-2"></i>وضعیت تسهیلات</h6>
          </template>
          <template v-slot:content>
            <div v-if="ChartLoaded == 'loading'" class="row pr-3">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="container-fluid" dir="ltr">
              <apexchart v-if="$store.state.renderComponent" type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="container-fluid" dir="rtl">
          <div class="row">
            <div class="col-12 text-right border-bottom">
              <span class="font-weight-bold mx-2" style="font-size: 12 !important">
                <i class="fas fa-comment-alt text-info"></i>
              </span>
              <span class="font-weight-bold mx-2" style="font-size: 12 !important">
                {{ Notfheader }}
              </span>
              <span class="font-weight-bold mx-2" style="font-size: 12 !important">
                {{ NotifDate }}
              </span>
            </div>
            <div class="col-12 mt-2 text-justify" style="line-height: 2 !important; font-size: 14px !important" dir="rtl">
              {{ NotifTxt }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalBanafash>
        <div class="row" dir="rtl" style="max-height: 75vh; overflow-y: scroll">
          <div class="col-12 pr-0" v-for="(item, index) in Tabloo" :key="index">
            <div class="col-12 pr-0">
              <div class="col-12 py-1 mx-0 text-right">
                <i class="fas fa-comment-alt ml-2 text-info"></i>
                <span class="font-weight-bold"> {{ item.subjectTabloElanat }}</span>
                <span class="mr-3 float-left">{{ item.zamanInsert }} </span>
              </div>
              <div class="col-12 px-1 mt-2">
                <div class="row">
                  <div class="col-12 text-justify" style="max-width: 100%" dir="rtl">
                    {{ item.txtMatnTabloElanat }}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalSuccess>
        <debtor></debtor>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from '../Tools/ModalCustom.vue'

import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Debtor from './Debtor.vue'
export default {
  components: { NetPaCard, ModalCustom, Debtor },
  data() {
    return {
      DataAxiosTabloo: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Tabloo',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosReqNeedVam: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaeedZamen',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosMoavaghat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Moavaghaat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosChart: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosFastPaymnet: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Fastpayment',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      ListReqNeedVam: [],
      Tabloo: 'loading',
      Moavaghaat: null,
      Notfheader: '',
      NotifTxt: '',
      NotifDate: '',
      Mab: '0',
      ChartLoaded: 'loading',
      FastpaymentData: [],
      SumMabFastPay: 0,
      SumJarmieFastPay: 0,
      VamCoutFastPay: 0,
      TablooLength: 0,
      SumMablagh: 0,
      chartData: {},
      series: [
        {
          name: 'اقساط پرداخت شده',
          data: [],
        },
        {
          name: 'اقساط پرداخت نشده',
          data: [],
        },
        {
          name: 'وام تسویه شده',
          data: [],
        },
        {
          name: 'اقساط معوقه',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '40%',
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        title: {
          text: '',
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },
        colors: ['#435ebe', '#f89215', '#67b221', '#E52505'],
      },
      Dargah: null,
      accessMenu1: 0,
      accessMenu2: 0,
      accessMenu4: 0,
      accessMenu3: 0,
    }
  },
  methods: {
    RqNeedVam(IdNeedVam, Status) {
      if (Status == 1) {
        this.$SweetQustion('توجه', 'از تایید ضمانت خود اطمینان دارید؟', 'warning', 'اطمینان دارم', 'منصرف شدم', IdNeedVam, this.AcceptVam, this.Cancel)
      } else {
        this.$SweetQustion('توجه', 'از رد ضمانت خود اطمینان دارید؟', 'warning', 'اطمینان دارم', 'منصرف شدم', IdNeedVam, this.UnAcceptVam, this.Cancel)
      }
    },
    AcceptVam(id) {
      var UpdTaeedZemanat = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'UpdTaeedZemanat',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('Id', id)
      formData.append('Status', 1)
      UpdTaeedZemanat.ArryfildValue = formData
      this.$PostFormData(UpdTaeedZemanat).then((data) => {
        if (data.success == 'SUCCESS') {
          this.$mySweetDefaultTost('عملیات موفق', 'درخواست ضمانت باموفقیت تایید شد .', 'success', 2000)
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
          })
          this.GetReqNeedVam()
        }
      })
    },
    UnAcceptVam(id) {
      var UpdTaeedZemanat = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'UpdTaeedZemanat',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('Id', id)
      formData.append('Status', 2)
      UpdTaeedZemanat.ArryfildValue = formData
      this.$PostFormData(UpdTaeedZemanat).then((data) => {
        if (data.success == 'SUCCESS') {
          this.$mySweetDefaultTost('عملیات موفق', 'درخواست ضمانت باموفقیت رد شد .', 'success', 2000)
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
          })
          this.GetReqNeedVam()
        }
      })
    },
    GetTablooElanat() {
      if (this.$session.get("CustCode")=="801") {
         const formData = new FormData()
        formData.append('ShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        formData.append('wwwtblTafsiliTypeId', this.$session.get('UserInfoNetPa').wwwtblTafsiliTypeId)
        this.DataAxiosTabloo.ArryfildValue = formData
        this.DataAxiosTabloo.Action = "Tabloo/GetTablooV2"
        this.$PostFormData(this.DataAxiosTabloo).then((data) => {
          this.Tabloo = data
          this.TablooLength = this.Tabloo.length
        })
      }
      else{
        const formData = new FormData()
        formData.append('ShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        formData.append('AzaNoId', this.$session.get('UserInfoNetPa').wwwtblAzaNoeId)
        this.DataAxiosTabloo.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosTabloo).then((data) => {
          this.Tabloo = data
          this.TablooLength = this.Tabloo.length
        })
      }
    },
    GetReqNeedVam() {
      const formData = new FormData()
      formData.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
      formData.append('Today', this.$GetJalaliDate())
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      this.DataAxiosReqNeedVam.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosReqNeedVam).then((data) => {
        this.ListReqNeedVam = data
        console.log(data)
      })
    },
    GetMoavaghat() {
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      this.DataAxiosMoavaghat.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosMoavaghat).then((data) => {
        this.Moavaghaat = data
        this.$store.state.renderComponent = false
        window.dispatchEvent(new Event('resize'))
        this.$nextTick(() => {
          this.$store.state.renderComponent = true
        })
      })
    },
    ShowFullNotif(Notif) {
      this.Notfheader = Notif.subjectTabloElanat
      this.NotifTxt = Notif.txtMatnTabloElanat
      this.NotifDate = Notif.zamanInsert
    },
    GetDataForChart() {
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 1)
      this.DataAxiosChart.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosChart).then((data) => {
        this.chartData = data
        this.TedadKolevmaha = data.length
        data.forEach((element) => {
          if (element.mande != 0) {
            this.chartOptions.xaxis.categories.push(element.desNoe)
            this.series[0].data.push(element.tedadAghsatPardaxtShode)
            if (element.tedadMoavaghe > 0) {
              this.series[3].data.push(element.tedadMoavaghe)
              this.series[1].data.push(element.tedadAghsatPardaxtNaShode - element.tedadMoavaghe)
            } else {
              this.series[3].data.push(0)
              this.series[1].data.push(element.tedadAghsatPardaxtNaShode)
            }

            this.series[2].data.push(0)
          } else {
            this.chartOptions.xaxis.categories.push(element.desNoe)

            this.series[0].data.push(0)
            this.series[1].data.push(0)
            this.series[3].data.push(0)
            this.series[2].data.push(element.tedadAghsatPardaxtShode)
          }
          // this.chartOptions.plotOptions.bar.barHeight = data.length==1? 0.1:0.4
        })
        this.ChartLoaded = 'true'
        this.$store.state.renderComponent = false
        window.dispatchEvent(new Event('resize'))
        this.$nextTick(() => {
          this.$store.state.renderComponent = true
        })
      })
    },
    GetFastpaymentData() {
      if (this.$session.get('UserInfoNetPa').wwwtblAzaId) {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 1)
        this.DataAxiosFastPaymnet.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosFastPaymnet).then((data) => {
          if (data.data) {
            for (var i = 0; i < data.data.length; i++) {
              var element = data.data[i]
              data.data[i].Active = true
              this.SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
            }
            this.FastpaymentData = data.data
            this.$store.state.renderComponent = false
            window.dispatchEvent(new Event('resize'))
            this.$nextTick(() => {
              this.$store.state.renderComponent = true
            })
          }
        })
      } else {
        this.FastpaymentData = []
      }
    },
    ShowAllNotifications() {},
    Pay() {
      if (this.Dargah == null) {
        this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
      } else {
        const WwwtblVarizGorohiRiz = []
        for (let index = 0; index < this.TotalFastPay.listFastpay.length; index++) {
          console.log('!!', this.TotalFastPay.listFastpay[index].wwwjarime)
          WwwtblVarizGorohiRiz.push({
            WwwtblTaahodatId: this.TotalFastPay.listFastpay[index].id,
            Mablagh: this.TotalFastPay.listFastpay[index].mablghPardakht,
            SharhRiz: ' پرداخت سریع قسط تسهیلات ' + this.TotalFastPay.listFastpay[index].vCode,
            WwwtblAzaId: this.$session.get('UserInfoNetPa').wwwtblAzaId,
            BnpCashDBtblTaahodatId: this.TotalFastPay.listFastpay[index].bnpCashDBtblTaahodatId,
            BnpCashDBtblAzaId: this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId,
            MablaghJarime: this.TotalFastPay.listFastpay[index].wwwjarime == null ? 0 : this.TotalFastPay.listFastpay[index].wwwjarime,
            TarixGhest: this.TotalFastPay.listFastpay[index].minTarGhestBedehkar,
          })
        }
        this.SumMablagh = this.TotalFastPay.SumMabFastPay
        this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
        this.DataAxios_Variz.ArryfildValue.Sharh = 'پرداخت اقساط گروهی'
        this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('UserInfoNetPa').custCode)
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.$session.get('UserInfoNetPa').wwwtblAzaId
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
        console.log(this.DataAxios_Variz.ArryfildValue)
        this.$PostData(this.DataAxios_Variz).then((result) => {
          this.$Payment(
            JSON.stringify(this.Dargah),
            JSON.stringify(this.SumMablagh),
            this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily,
            this.$session.get('UserInfoNetPa').email,
            this.$session.get('UserInfoNetPa').mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            '',
            this.TotalFastPay.listFastpay[0].vCode,
            'سبد اقساط',
            JSON.stringify(this.$session.get('UserInfoNetPa').wwwtblAzaId),
            this.$session.get('UserInfoNetPa').custCode,
            JSON.stringify(this.$session.get('UserInfoNetPa').wwwtblShobeId),
            result.idRepoMaster,
            this.$session.get('UserInfoNetPa').codeMeli
          )
        })
      }
    },
  },
  mounted() {
    this.accessMenu1 = this.$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu
    this.accessMenu2 = this.$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu
    this.accessMenu3 = this.$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu
    this.accessMenu4 = this.$session.get('AccessMenu').filter((x) => x.id == 20)[0].isMenu

    //   this.accessMenu1=true
    //   this.accessMenu2=true
    //   this.accessMenu3=true
    //   this.accessMenu4=true
    //خواندن اطلاعات درگاه از دیتابیس
    this.$Gateway().then((data) => {
      if (data.status == 'Ok') {
        data.data.forEach((element) => {
          if ((element.gatewayCode != null || element.gatewayCode != '') && element.isDefault == true) {
            this.Dargah = element.id
          }
        })
      } else {
        this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'warning', 2000)
      }
    })

    this.GetFastpaymentData()
    this.GetDataForChart()
  },
  computed: {
    TotalFastPay() {
      var shomarande = 0
      var SumMabFastPay = 0
      var VamCoutFastPay = 0
      var SumJarmieFastPay = 0
      var listFastpay = []
      for (let index = 0; index < this.FastpaymentData.length; index++) {
        const element = this.FastpaymentData[index]
        if (element.Active) {
          shomarande++
          SumMabFastPay += element.mablghPardakht
          SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
          listFastpay.push(element)
        }
      }
      VamCoutFastPay = shomarande
      return {
        VamCoutFastPay: VamCoutFastPay,
        SumJarmieFastPay: SumJarmieFastPay,
        SumMabFastPay: SumMabFastPay,
        listFastpay: listFastpay,
      }
    },
  },
  updated() {
    this.$PutCommatoInput()
    this.accessMenu1 = this.$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu
    this.accessMenu2 = this.$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu
    this.accessMenu3 = this.$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu
  },
  created() {
    this.GetReqNeedVam()
    this.GetTablooElanat()
    this.GetMoavaghat()
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 1080) {
      this.chartOptions.plotOptions.bar.horizontal = false
      this.chartOptions.chart.height = 550
      this.chartOptions.chart.width = 50
    }
  },
}
</script>

<style scoped>
.max-h-15 {
  max-height: 8vh !important;
  overflow-y: hidden;
}
.textVerticalCenter {
  position: absolute;
  top: 30%;
  white-space: nowrap;
  right: 15%;
}
.bg-dark {
  background: #2a3f54 !important;
}
.border-danger {
  border-right: 2px solid #d10000 !important;
}
.badge-success {
  background: #67b221 !important;
  border-radius: 15px;
}
.btn-outline-dark:hover {
  background: none;
  color: rgb(41, 41, 41) !important;
}
</style>
<style>
tspan {
  font-family: '';
}


.animate__animated.animate__swing {
  --animate-duration: 1s;
}
</style>
